import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Box } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { actions as productActions } from '../redux/productActions';
import ProductDetails from '../components/ProductDetails/ProductDetails';

const ProductListContainer = () => {
  const { user } = useSelector((state) => state.auth);
  const availableProducts = getIncludedResource(
    user.data,
    user.included,
    'available_products',
  );

  const productOrder = [
    'Leisure Travel',
    'Smart Luggage',
    'Cancer Cover',
    'Hospital Cash Plan',
    'Personal Accident',
    'Surgery Cash Plan',
  ];

  Array.isArray(availableProducts)
    ? availableProducts.sort((a, b) => {
        return (
          productOrder.indexOf(a.attributes.name) -
          productOrder.indexOf(b.attributes.name)
        );
      })
    : [];

  return (
    <InternalContainer hideBreadcrumbs={true} title="Products">
      <Box className={'dashboard-product-container animated fadeIn'}>
        {availableProducts.map((product) => {
          return <ProductDetails key={product.id} user={user} product={product} />;
        })}
      </Box>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    clearData: productActions.clearData,
  },
)(ProductListContainer);
